/**
 * The crosshair snaps to a bar (owner, 2026-10-05: always, not within a
 * distance). A free vertical line stands between two days and names neither;
 * the axis label under it then reads a time no bar has.
 *
 * Pure so it can be tested without SciChart: the shell hands in the pane's bar
 * times in ascending order, as its X data already holds them.
 */

/**
 * The bar time nearest `time`, or `undefined` when there are no bars.
 *
 * Binary search, because this runs on every pointer move over series of
 * thousands of bars. A tie goes to the later bar — the one the pointer is
 * moving towards on a rightward sweep, and the usual chart convention.
 */
export function nearestBarTime(
  times: { length: number; [index: number]: number } | ((index: number) => number),
  length: number,
  time: number,
): number | undefined {
  if (length === 0 || !Number.isFinite(time)) return undefined;
  const at = typeof times === "function" ? times : (i: number) => times[i]!;
  let lo = 0;
  let hi = length - 1;
  if (time <= at(lo)) return at(lo);
  if (time >= at(hi)) return at(hi);
  // Invariant: at(lo) < time < at(hi).
  while (hi - lo > 1) {
    const mid = (lo + hi) >> 1;
    if (at(mid) <= time) lo = mid;
    else hi = mid;
  }
  const before = at(lo);
  const after = at(hi);
  return time - before < after - time ? before : after;
}
